/**
 * Permission names the web app checks. The API is the authority
 * (apps/api/src/common/permissions.ts, sent in auth/me as the union of the user's roles);
 * this list only names them so routes and menus can be guarded. Site and client scope are
 * enforced by the API (TenantScope).
 */
export const P = {
  parcelsView: 'parcels.view',
  parcelsEdit: 'parcels.edit',
  parcelsUnmask: 'parcels.unmask',
  tagsBind: 'tags.bind',
  tagsRelabel: 'tags.relabel',
  labelsPrint: 'labels.print',
  preadvice: 'preadvice.manage',
  receive: 'receiving.receive',
  putaway: 'putaway.move',
  holdsPlace: 'holds.place',
  holdsRelease: 'holds.release',
  exceptionsOpen: 'exceptions.open',
  exceptionsWork: 'exceptions.work',
  exceptionsClose: 'exceptions.close',
  lostFound: 'lostfound.approve',
  sort: 'sort.sort',
  containers: 'containers.manage',
  manifests: 'manifests.manage',
  load: 'dispatch.load',
  handover: 'dispatch.handover',
  rts: 'rts.manage',
  deliveryReport: 'delivery.report',
  overrides: 'overrides.approve',
  countsRun: 'counts.run',
  countsManage: 'counts.manage',
  countsApprove: 'counts.approve',
  reports: 'reports.view',
  audit: 'audit.view',
  exports: 'exports.run',
  privacy: 'privacy.manage',
  sites: 'sites.manage',
  locations: 'locations.manage',
  clients: 'clients.manage',
  routes: 'routes.manage',
  reasons: 'reasons.manage',
  devices: 'devices.manage',
  settings: 'settings.manage',
  users: 'users.manage',
  groups: 'groups.manage',
  roles: 'roles.manage',
  apiKeys: 'apikeys.manage',
  webhooks: 'webhooks.manage',
  supportApprove: 'support.approve',
  portalView: 'portal.view',
  portalAdmin: 'portal.admin',
  portalRequest: 'portal.request',
  platformOrgs: 'platform.orgs',
  platformSupport: 'platform.support',
  platformHealth: 'platform.health',
} as const;

export type PermissionName = (typeof P)[keyof typeof P];
